module.exports = __webpack_public_path__ + "static/media/dashboard.3aacac0f.png";